
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/patients/support.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
// @ts-check
import React from 'react';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import ConfluenceArticle from '@components/UI/ConfluenceArticle';
import PatientMediaPermissionsWarning from '@components/MediaPermissions/PatientMediaPermissionsWarning';
import { useTranslation } from 'react-i18next';
import Header from '@components/Layouts/Header/Header';

const Support = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <div className="page-container">
      <Header pageType="patients" pageTitle="Patient Support" />

      <section className="section-layout patient">
        <main className="container" id="page-content">
          <PatientMediaPermissionsWarning />
          <ConfluenceArticle id="CONF_SUPPORT" />
        </main>
      </section>
    </div>
  );
};


export const Route = createFileRoute('/patients/support')({ component: Support });
